"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNativeModuleLoaded = exports.isValidCallback = void 0;
var invariant_1 = __importDefault(require("invariant"));
function isValidCallback(handler) {
    invariant_1.default(typeof handler === 'function', 'Must provide a valid callback');
}
exports.isValidCallback = isValidCallback;
function isNativeModuleLoaded(module) {
    if (module == null) {
        console.error('Could not load RNOneSignal native module. Make sure native dependencies are properly linked.');
        return false;
    }
    return true;
}
exports.isNativeModuleLoaded = isNativeModuleLoaded;
